export const SMALL_PHONE_MAX_WIDTH = 420;
export const PHONE_MAX_WIDTH = 560;
export const TABLET_MAX_WIDTH = 768;
export const DESKTOP_MAX_WIDTH = 1024;
